<template>
    <div v-if="video.Certification">
        <div style="">
            <div
                v-if="video.Link"
                ref="popup"
                class="video-link rl-rel rl-popup">
                <a :href="video.Link">
                    <img
                        ref="popupLink"
                        :src="video.ImageSrc"
                        class="rl-img-response"
                        alt=""
                        srcset="">
                    <div class="rl-play-wrapper">
                        <i class="rl-play"/>
                    </div>
                </a>
            </div>

            <div
                v-if="video.Link === ''"
                class="video-link rl-rel rl-popup-image">
                <a
                    :href="video.Pictures[0]"
                    style=""
                    class="">
                    <img
                        :src="video.Pictures[0]"
                        class="rl-img-response">
                    <div class="rl-play-wrapper">
                        <i class="rl-play"/>
                    </div>
                </a>
                <a
                    v-for="(item, index) in video.Pictures"
                    :href="item"
                    :key="index"/>
            </div>
        </div>
        <div
            ref="video"
            :title="video.Title"
            class="video-title">
            {{ video.Title }}
        </div>

        <div
            :class="{showVideoDesc: isShowDesc}"
            class="videoDescWrapper">
            <div
                ref="videoDesc"
                class="video-desc"
                v-html="video.Description"/>
            <span
                v-if="isShowMore"
                ref="morebutton"
                class="moreButton"
                @click="showDesc">...More</span>
        </div>
        <div
            v-show="currentType === undefined || currentType === 'feature-showcase' || currentType === 'tutorials'"
            class="video-author rl-text-right">By {{ video.Author }} </div>
    </div>
</template>
<script>
    export default {
        props: {
            video: {
                type: Object,
                required: true
            },
            imgdomain: {
                type: String,
                required: true
            },
            currentTab: {
                type: Number,
                required: true
            },
            currentType: {
                type: String,
                required: false,
                default: ""
            },
            immediateLink: String
        },
        data () {
            return {
                isShowMore: false,
                isShowDesc: false
            };
        },
        watch: {
            currentTab: function () {
                const vm = this;
                vm.$nextTick(function () {
                    $(document).ready(function () {
                        vm.limitLineNumber();
                    });
                });
            }
        },
        created () {
        },
        mounted: function () {
            const vm = this;
            this.$nextTick(function () {
                $(document).ready(function () {
                    vm.popupVideo(".rl-popup");
                    vm.popupImage(".rl-popup-image");
                    vm.limitLineNumber();
                    if (vm.video.Link === vm.immediateLink) {
                        const elem = vm.$refs.popupLink;
                        setTimeout(function () {
                            elem.click();
                        }, 1000);
                    }
                });
                window.addEventListener("resize", function () {
                    vm.limitLineNumber();
                });
            });
        },
        updated: function () {
            const vm = this;
            vm.$nextTick(function () {
                $(document).ready(function () {
                    vm.limitLineNumber();
                });
            });
        },
        methods: {
            limitLineNumber: function () {
                const vm = this;
                if (vm.$refs.videoDesc !== undefined) {
                    vm.isShowMore = vm.$refs.videoDesc.clientHeight > 115;
                } else {
                    vm.isShowMore = false;
                }
            },
            showDesc: function () {
                const vm = this;
                if (!vm.isShowDesc) {
                    vm.$refs.morebutton.innerHTML = "Less";
                } else {
                    vm.$refs.morebutton.innerHTML = "...More";
                }

                vm.isShowDesc = !vm.isShowDesc;
            }
        }
    };
</script>
<style lang="scss">
    .mfp-iframe-holder .mfp-content {
        max-width: 80% !important;
    }

    .swiper-container .video-link {
        border: 1px solid #c3c3c3;
    }

    .swiper-container .video-title {
        margin-top: 20px;
        margin-bottom: 20px;
        min-height: 52px;
        font-weight: 500;
        font-size: 20px;
        max-height: 52px;
        overflow: hidden;
        color: #555;
        line-height: normal;
        position: relative;
    }

    .swiper-container .video-desc {
        font-size: 16px;
        line-height: 1.45;
        color: #555;
    }

    .swiper-container .video-author {
        margin-top: 20px;
        font-size: 16px;
        color: #555;
    }
</style>



// WEBPACK FOOTER //
// src/components/slick-tab.vue